import { Observable } from 'rxjs';
import { LanguageOption } from './i18n.types';

export abstract class I18nFacade {
  abstract readonly currentLanguage$: Observable<string>;

  abstract setLanguage(lang: string): void;
  abstract getCurrentLanguage(): string;
  abstract getAvailableLanguages(): LanguageOption[];
  abstract instant(key: string, params?: Record<string, unknown>): string;
}
